import LiveTrackCard from "../../components/liveTrackComponent/liveTrackCard/liveTrackCard";
import LiveTrackContent from "../../components/liveTrackComponent/liveTrackContent/liveTrackContent";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import VideoSec from "../../components/videoSec/videoSec";
import {useState} from "react";

const LiveTrack = () => {
    const isDVR = true;

    return(
        <>
            <div className={'content-section page-fade-in'}>
                <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                    <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>

                {/*...... live track cards .....*/}
                <div className="margin-b-30"><LiveTrackCard/></div>


                {/*....... video section ......*/}
                <div className="margin-b-40">
                    <div className="section-title margin-b-20">Critical Alert Videos</div>
                    <VideoSec isDVR={isDVR} />
                </div>

                {/*......live track details ........*/}
                <div className=""><LiveTrackContent onRequestDVR={isDVR}/></div>
            </div>
        </>
    )

}

export default LiveTrack;
